import React, { useState, useEffect } from 'react';
import LoadingSpinner from '../components/LoadingSpinner';
import api from '../services/api';
import './AdminPagos.css';

const AdminPagos = () => {
  const [datos, setDatos] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [marcando, setMarcando] = useState(null);
  const [expandido, setExpandido] = useState(null);

  const cargarDatos = async () => {
    try {
      setCargando(true);
      const res = await api.get('/admin/pagos-fotografos');
      setDatos(res.data);
    } catch (e) {
      setError('Error al cargar los pagos');
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => { cargarDatos(); }, []);

  const marcarPagado = async (fotografoId, nombre) => {
    if (!window.confirm(`¿Marcar todas las ganancias pendientes de ${nombre} como pagadas?`)) return;
    setMarcando(fotografoId);
    try {
      await api.post(`/admin/pagos-fotografos/${fotografoId}/marcar-pagado`);
      await cargarDatos();
    } catch (e) {
      alert('Error al marcar como pagado');
    } finally {
      setMarcando(null);
    }
  };

  const fmt = (n) => `$${(n || 0).toFixed(2)} MXN`;

  if (cargando) return <LoadingSpinner mensaje="Cargando pagos..." />;
  if (error) return <div className="admin-pagos-error">{error}</div>;

  return (
    <div className="admin-pagos">
      <h1>💰 Pagos a Fotógrafos</h1>

      <div className="admin-resumen-cards">
        <div className="admin-card pendiente">
          <div className="admin-card-label">Total pendiente de pago</div>
          <div className="admin-card-valor">{fmt(datos?.totalPendientePago)}</div>
        </div>
        <div className="admin-card comision">
          <div className="admin-card-label">Comisión plataforma (20%)</div>
          <div className="admin-card-valor">{fmt(datos?.totalComisionPlataforma)}</div>
        </div>
        <div className="admin-card fotografos">
          <div className="admin-card-label">Fotógrafos activos</div>
          <div className="admin-card-valor">{datos?.fotografos?.length || 0}</div>
        </div>
      </div>

      <div className="admin-fotografos-lista">
        {datos?.fotografos?.length === 0 && (
          <p className="admin-sin-datos">No hay ventas registradas aún.</p>
        )}
        {datos?.fotografos?.map((f) => (
          <div key={f.fotografoId} className="admin-fotografo-card">
            <div className="admin-fotografo-header" onClick={() => setExpandido(expandido === f.fotografoId ? null : f.fotografoId)}>
              <div className="admin-fotografo-info">
                <span className="admin-fotografo-nombre">📷 {f.nombre}</span>
                <span className="admin-fotografo-email">{f.email}</span>
                {f.stripeConectado && (
                  <span className="badge-mp-conectado">💳 Stripe conectado</span>
                )}
              </div>
              <div className="admin-fotografo-montos">
                <div className="admin-monto-pendiente">
                  <span className="admin-monto-label">Pendiente</span>
                  <span className="admin-monto-valor rojo">{fmt(f.gananciaPendiente)}</span>
                </div>
                <div className="admin-monto-pagado">
                  <span className="admin-monto-label">Ya pagado</span>
                  <span className="admin-monto-valor verde">{fmt(f.gananciaYaPagada)}</span>
                </div>
                <div className="admin-monto-ventas">
                  <span className="admin-monto-label">Ventas</span>
                  <span className="admin-monto-valor">{f.totalVentas}</span>
                </div>
              </div>
              <div className="admin-fotografo-acciones">
                {f.gananciaPendiente > 0 && (
                  <button
                    className="btn-marcar-pagado"
                    disabled={marcando === f.fotografoId}
                    onClick={(e) => { e.stopPropagation(); marcarPagado(f.fotografoId, f.nombre); }}
                  >
                    {marcando === f.fotografoId ? 'Marcando...' : '✅ Marcar pagado'}
                  </button>
                )}
                <span className="admin-expand-icon">{expandido === f.fotografoId ? '▲' : '▼'}</span>
              </div>
            </div>

            {expandido === f.fotografoId && (
              <div className="admin-ventas-detalle">
                <table className="admin-tabla">
                  <thead>
                    <tr>
                      <th>Venta ID</th>
                      <th>Foto ID</th>
                      <th>Monto total</th>
                      <th>Ganancia fotógrafo (80%)</th>
                      <th>Comisión (20%)</th>
                      <th>Comprador WhatsApp</th>
                      <th>Fecha</th>
                      <th>Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {f.ventas.map((v) => (
                      <tr key={v.ventaId} className={v.pagado ? 'fila-pagada' : 'fila-pendiente'}>
                        <td>#{v.ventaId}</td>
                        <td>#{v.fotoId}</td>
                        <td>{fmt(v.montoTotal)}</td>
                        <td className="verde">{fmt(v.gananciaFotografo)}</td>
                        <td>{fmt(v.comision)}</td>
                        <td>{v.whatsappComprador || '—'}</td>
                        <td>{v.fechaVenta ? new Date(v.fechaVenta).toLocaleDateString('es-MX') : '—'}</td>
                        <td>
                          {v.pagado
                            ? <span className="badge-pagado">{v.pagoAutomaticoSplit ? '⚡ Pagado automático' : '✅ Pagado'}</span>
                            : <span className="badge-pendiente">⏳ Pendiente</span>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminPagos;
